export class ShipmentTripLists {
    "date": string = "";
    "asn_number": string = "";
    "trip_number": string = "";
    "external_bill_of_lading": string | null = null;    
    "act_trail_number": string | null = null;
    "trailer_id": string | null = null;
    "trip_list_uuid": string = "";
    "week_no": number = 0;
    "total_cartons": number = 0;
    "manifest_carton_count": number = 0;
    "bol_carton_count": number = 0;
    "reported_weight": number = 0;    
    "archive": number = 0;       
    "created": string = "";

    "blind_scan": boolean = false;
    "customer_contact_uuid": string | null = null;
    "pool_point_uuid": string | null = null;
    "inventory_warehouse_uuid": string | null = null;
    "total_ladings": number = 0;

    "customer_display_name": string = "";
    "contact_organization": string | null = null;
    "customer_name": string | null = null;
    "customer_contact_organization": string | null = null;
    "inventory_warehouse_customer_name": string | null = null;
    "trip_list_customer_contact_uuid": string | null = null;
}
